/*
  artvision® · Artist Package · Freischalt-Link
  Angenommene Bewerber bekommen einen Link wie
  /products/paket-academy?zugang=CODE. Stimmt der Code, zeigen alle
  Handlungswege der Seite statt "Bewerben" den Kauf-Button.

  Im Quelltext steht nur der SHA-256-Hash des Codes (aus dem
  Paket-Kopf). Die Freischaltung wird pro Paket im Browser gemerkt,
  damit sie nach Warenkorb/Zurück noch gilt. Wird der Code im
  Customizer geändert, verfallen alte Links und alte Freischaltungen.
*/
(function () {
  var cfgEl = document.querySelector('script[data-av-pkg-unlock]');
  if (!cfgEl) return;

  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  if (!cfg || !cfg.hash) return;

  var storeKey = 'av-pkg-unlock:' + cfg.product;

  function unlock() {
    document.querySelectorAll('[data-av-pkg-cta]').forEach(function (cta) {
      var buy = cta.querySelector('[data-av-pkg-buy]');
      if (!buy) return;
      var apply = cta.querySelector('[data-av-pkg-apply]');
      if (apply) apply.hidden = true;
      buy.hidden = false;
    });
    document.documentElement.setAttribute('data-av-pkg-unlocked', '');

    /* Zahlweise festsetzen: Der Link gilt für genau ein Abo. Der
       Umschalter verschwindet (CSS), av-billing.js liest die Sperre
       beim Start bzw. bekommt sie per Event, falls es schon lief. */
    if (cfg.billing === 'yearly' || cfg.billing === 'monthly') {
      document.documentElement.setAttribute('data-av-billing-lock', cfg.billing);
      document.dispatchEvent(new CustomEvent('av:billing:lock', { detail: { mode: cfg.billing } }));
    }
  }

  function remembered() {
    try { return window.localStorage.getItem(storeKey) === cfg.hash; } catch (e) { return false; }
  }

  function remember() {
    try { window.localStorage.setItem(storeKey, cfg.hash); } catch (e) { /* egal */ }
  }

  function sha256(text) {
    if (!window.crypto || !window.crypto.subtle || !window.TextEncoder) return Promise.reject();
    return window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(text)).then(function (buf) {
      return Array.prototype.map.call(new Uint8Array(buf), function (b) {
        return ('0' + b.toString(16)).slice(-2);
      }).join('');
    });
  }

  if (remembered()) { unlock(); return; }

  var code;
  try { code = new URLSearchParams(window.location.search).get('zugang'); } catch (e) { code = null; }
  if (!code) return;

  sha256(code.trim().toLowerCase()).then(function (hash) {
    if (hash !== cfg.hash) return;
    remember();
    unlock();
  }).catch(function () { /* ohne Web Crypto bleibt es bei der Bewerbung */ });
})();
